<div class="wrapper">
  <i [class.fi-heart-filled]="isSelfUserReaction()" [class.fi-heart]="!isSelfUserReaction()" (click)="toggleLike()">
  </i>
  <span class="like-amount" [class.active]="isSelfUserReaction()">{{ likeCount }}</span>
</div>
